/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth from '@material-ui/core/withWidth';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import PlaceOrderComponent from '../../Components/PlaceOrder/PlaceOrder.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import PageSingleColumn from '../Layouts/PageSingleColumn';
import './PlaceOrder.page.i18n';
import PlaceOrderPagePropTypes from './PlaceOrder.page.props';
import PlaceOrderPageStyles from './PlaceOrder.page.styles';

/**
 * PlaceOrderPageComponent
 * @export
 * @class PlaceOrderPageComponent
 * @extends {React.Component<PlaceOrderPageComponentComposedProps, PlaceOrderPageComponentState>}
 */
export class PlaceOrderPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<PlaceOrderPageComponentProps>}
   * @memberof PlaceOrderPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`PlaceOrderPage`}
   * @memberof PlaceOrderPageComponent
   */
  static displayName = `PlaceOrderPage`;

  static propTypes = PlaceOrderPagePropTypes;

  /**
   * Data specific to the `<PlaceOrderPage />` instance
   * @type {PlaceOrderPageComponentState}
   * @memberof PlaceOrderPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<PlaceOrderPage />`
   * @memberof PlaceOrderPageComponent
   */
  render() {
    return (
      <PageSingleColumn defaultLanguageHeading="Order Concrete" englishTitle="Order Concrete" overflow="auto" title="Order Concrete">
        <Typography variant="body2" style={{ margin: '16px 0', textAlign: 'left', backgroundColor: '#f1f8e9', padding: '8px 16px', borderRadius: 4 }}>
          <span style={{ color: '#388e3c', fontWeight: 600 }}>
            Important Pricing Update:
          </span>{' '}
          Effective <span style={{ fontWeight: 600 }}>14<sup>th</sup> October 2026</span>, a Production
          and Transport Surcharge of <span style={{ fontWeight: 600 }}>$13.44 ex GST per m³</span>{' '}
          will apply, due to the recent escalation in global energy and commodity markets which is significantly impacting production and supply chain costs.
        </Typography>
        <PlaceOrderComponent />
      </PageSingleColumn>
    );
  }
}

/** @type {React.ComponentClass<PlaceOrderPageComponentProps>} */
const PlaceOrderPage = compose(
  withEntries,
  withRouter,
  withServices,
  withWidth(),
  withStyles(themeCreateInjectableStyles(PlaceOrderPageStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(PlaceOrderPageComponent);

export default PlaceOrderPage;
